import React from 'react'
import PropTypes from 'prop-types'

import {
  StyledButton,
  StyledCKEditorContent,
  StyledContainer,
  StyledHeading,
  StyledIcon,
  StyledLabel,
  StyledRedirectionHighlight,
} from './RedirectionHighlight.styled'

import ButtonVariantEnum from '../../enums/ButtonVariant'
import { HeadingSizeEnum } from '../Heading/Heading'
import useCtaLink from '../../hooks/useCtaLink'

const RedirectionHighlight = (props) => {
  const { ctaLabel, ctaUrl: href, description, title } = props

  const [ctaUrl, ctaSlug] = useCtaLink(href)

  return (
    <StyledRedirectionHighlight>
      <StyledContainer>
        <StyledHeading label={title} size={HeadingSizeEnum.h3} />
        {description?.content && (
          <StyledCKEditorContent html={description?.content} />
        )}
      </StyledContainer>
      <StyledButton
        href={ctaUrl}
        target={ctaUrl && `_blank`}
        to={ctaSlug}
        variant={ButtonVariantEnum.primary}
      >
        <StyledLabel>{ctaLabel}</StyledLabel>
        <StyledIcon />
      </StyledButton>
    </StyledRedirectionHighlight>
  )
}

RedirectionHighlight.propTypes = {
  ctaLabel: PropTypes.string.isRequired,
  ctaUrl: PropTypes.string.isRequired,
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default RedirectionHighlight
